/**
 * The first element carrying `data-tour="<id>"` that is actually on screen.
 *
 * Several pages render a control twice and hide one copy with a breakpoint
 * class (the patients' quick filters sit inline on desktop and on their own
 * row below `lg`). `querySelector` alone would happily return the hidden one
 * and the tour would point at nothing.
 */
export function findTourTarget(id: string): HTMLElement | undefined {
  const all = document.querySelectorAll<HTMLElement>(
    `[data-tour="${CSS.escape(id)}"]`,
  );
  return Array.from(all).find((el) => el.getClientRects().length > 0);
}
